import { LoadingBox, Popup } from "component/basic/popup";
import { getParam } from "js/function";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PaymentSuccessPage = () => {
    const navigate = useNavigate();
    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);
    const [popupData,setPopupData] =  useState(null);

    const success = getParam("success")||"";
    const return_message = decodeURI(getParam("return_message"))||"";
    const id = getParam("id")||"";
    const type = getParam("type")||"";

    function storageChk(data){
        let type = false;
        if(data && data !== "undefined" && data !== "null"){
            type = true;
        }else{
            type = false;
        }

        return type;
    }

    useEffect(() => {
        if(success == "true"){
            navigate(`/reservation/detail/${id}`,{state: {pageType:type === "edit" ? "paymentEdit" : "payment",memberCode:storageChk(sessionStorage.getItem("memberCode")) ? JSON.parse(sessionStorage.getItem("memberCode")) : null}});
            setLoadingBoxOpen(false);
        }else if(success == "false"){
            setPopupData({
                addClass:null,
                title:"결제 실패",
                text:return_message ? return_message : "결제가 실패하였습니다.<br/>다시 확인 후 결제를 진행해 주세요.",
                closeType:false,
                closeFunc:(e) => {},
                btnFunc0:(e)=>{
                    navigate(sessionStorage.getItem("paymentUrl"),{
                        state: {
                            paymentData: storageChk(sessionStorage.getItem("paymentDataLoca")) ? JSON.parse(sessionStorage.getItem("paymentDataLoca")) : null,
                            carData: storageChk(sessionStorage.getItem("carData")) ? JSON.parse(sessionStorage.getItem("carData")) : null,
                            addTotalPriceSel: storageChk(sessionStorage.getItem("addTotalPriceSel")) ? Number(sessionStorage.getItem("addTotalPriceSel")) : null,
                            insuranceSel: storageChk(sessionStorage.getItem("insuranceSel")) ? JSON.parse(sessionStorage.getItem("insuranceSel")) : null,
                            reservationData: storageChk(sessionStorage.getItem("reservationData")) ? JSON.parse(sessionStorage.getItem("reservationData")) : null,
                            memberCode: storageChk(sessionStorage.getItem("memberCode")) ? JSON.parse(sessionStorage.getItem("memberCode")) : null,
                        }
                    });
                    setTimeout(() => {
                        sessionStorage.clear();
                    }, 200);
                },
                btn0:"확인",
                btn0Type:"",
                btn1:"",
                btn1Type:"",
                btnFunc1:()=>{}
            });
            setLoadingBoxOpen(false);
        }else{
            navigate("/");
        }
    }, []);

    return (
        <>
            <Popup
                data={popupData}
            />
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default PaymentSuccessPage;